module.exports = __webpack_public_path__ + "static/p5-05e854cf06f38bc56de82d22b321b343.jpg";